import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import useFetchDomains from "../../hooks/useFetchDomains";
import useFetchUserProfile from "../../hooks/useFetchUserProfile";
import useFetchPacks from "../../hooks/useFetchPacks";
import useUserPurchases from "../../hooks/useUserPurchases";
import { auth } from "../../services/firebase";
import "./InterviewPackScreen.css";

export default function InterviewPackScreen() {
    const navigate = useNavigate();

    const { domains, loadingDomainList } = useFetchDomains();
    const { profile, loadingProfile } = useFetchUserProfile();

    const [selectedDomain, setSelectedDomain] = useState("");

    const { packs, loadingPacks } = useFetchPacks(selectedDomain);
    const { purchasedPacks, loadingPurchases } = useUserPurchases(selectedDomain);

    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        if (profile?.domainId) setSelectedDomain(profile.domainId);
    }, [profile]);

    const handleOpen = (packId, packName) => {
        navigate(`/user/interviews/${selectedDomain}/${packId}/${packName}`);
    };

    const handleBuy = (pack, e) => {
        e.stopPropagation();
        navigate(`/user/billing/${pack.domainId}/${pack.id}`, { state: { pack } });
    };

    const isLoading =
        loadingProfile || loadingDomainList || loadingPacks || loadingPurchases;

    return (
        <div className="packs-container">

            {/* 📱 HAMBURGER BUTTON (Mobile Only) */}
            <button className="hamburger-btn" onClick={() => setDrawerOpen(true)}>
                ☰
            </button>

            {/* 📱 Drawer Overlay */}
            {drawerOpen && (
                <div className="drawer-overlay" onClick={() => setDrawerOpen(false)} />
            )}

            {/* ====================== SIDEBAR ====================== */}
            <div className={`sidebar ${drawerOpen ? "drawer-open" : ""}`}>
                <h2 className="sidebar-title">Dashboard</h2>

                <div className="dash-actions">
                    <button
                        className="dash-btn"
                        onClick={() => navigate("/user/profile")}
                    >
                        👤 My Profile
                    </button>

                    <button
                        className="dash-btn"
                        onClick={() => navigate("/user/purchases")}
                    >
                        🧾 Purchase History
                    </button>

                    <button
                        className="dash-btn"
                        onClick={() => navigate("/user/send-review")}
                    >
                        📝 Send Review
                    </button>

                    <button className="dash-btn" onClick={() => navigate("/faq")}>
                        ❓ FAQ
                    </button>

                    <button className="dash-btn" onClick={() => navigate("/about")}>
                        ℹ️ About
                    </button>

                    <button
                        className="dash-btn"
                        onClick={() => navigate("/contact")}
                    >
                        📩 Contact Us
                    </button>

                    <button
                        className="dash-btn logout"
                        onClick={() => {
                            if (window.confirm("Are you sure you want to logout?")) {
                                auth.signOut();
                                navigate("/");
                            }
                        }}
                    >
                        🔓 Logout
                    </button>

                </div>
            </div>

            {/* ====================== MAIN CONTENT ====================== */}
            <div className="main-content">
                <div className="top-header">
                    <h1 className="packs-title">Interview Packs</h1>

                    <select
                        value={selectedDomain}
                        onChange={(e) => setSelectedDomain(e.target.value)}
                        className="domain-dropdown"
                        disabled={loadingDomainList}
                    >
                        <option value="">Select Domain</option>
                        {domains.map((d) => (
                            <option key={d.id} value={d.id}>
                                {d.name}
                            </option>
                        ))}
                    </select>
                </div>

                {/* ===== LOADING ===== */}
                {isLoading ? (
                    <p className="loading-text">Loading...</p>
                ) : packs.length === 0 ? (
                    <p className="no-packs">No packs available for this domain.</p>
                ) : (
                    <div className="pack-grid">
                        {packs.map((p) => {
                            const purchase = purchasedPacks[p.id];
                            const expired = purchase?.expired;
                            const active = purchase?.active;

                            return (
                                <div
                                    key={p.id}
                                    className="pack-card"
                                    onClick={() => handleOpen(p.id, p.name)}
                                >
                                    <div className="pack-content">
                                        <h3>{p.name}</h3>
                                        {p.description && <p>{p.description}</p>}
                                    </div>

                                    <div className="btn-row">
                                        <button
                                            className="open-btn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleOpen(p.id, p.name);
                                            }}
                                        >
                                            Open
                                        </button>

                                        {(!active || expired) && (
                                            <button
                                                className="buy-btn"
                                                onClick={(e) => handleBuy(p, e)}
                                            >
                                                Buy
                                            </button>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}
